import React from 'react'
import PropTypes from 'prop-types'
import Image from 'js/components/DatoRichText/DatoImage'
import useBreakpoints from '../../../hooks/useBreakpoints'
import cn from 'classnames'

export default function ImageBlock({
  squareImage,
  rectangularImage,
  alignment,
}) {
  const { MD } = useBreakpoints()
  const selectedImage =
    MD && alignment !== 'justify' ? squareImage : rectangularImage
  const url = new URLSearchParams(selectedImage.url)
  const image = (
    <Image
      className="rounded-8 lg:rounded-16"
      base64={selectedImage.blurUpThumb}
      src={selectedImage.url}
      alt={selectedImage.alt}
      width={url.get('w')}
      height={url.get('h')}
      lazy
    />
  )

  return (
    <figure
      className={cn(
        'mb-24',
        alignment !== 'justify' && 'md:mt-6 md:w-1/2 xl:w-2/3',
        alignment === 'right' && 'md:float-right md:ml-32 xl:-mr-192 xl:ml-48',
        alignment === 'left' && 'md:float-left md:mr-32 xl:-ml-192 xl:mr-48',
      )}
    >
      {image}
      {selectedImage.caption && (
        <figcaption className="type-small mt-8 leading-body text-TypeSub">
          {selectedImage.caption}
        </figcaption>
      )}
    </figure>
  )
}

ImageBlock.propTypes = {
  squareImage: PropTypes.shape({
    title: PropTypes.string,
    blurUpThumb: PropTypes.string,
    alt: PropTypes.string,
    url: PropTypes.string,
  }),
  rectangularImage: PropTypes.shape({
    title: PropTypes.string,
    blurUpThumb: PropTypes.string,
    alt: PropTypes.string,
    url: PropTypes.string,
  }),
  alignment: PropTypes.oneOf(['justify', 'left', 'right']),
}
